import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import FeatherX from '../../atoms/static-icons/feather-x';
import './GenericModal.scss';

const GenericModal = ({
  isOpen,
  children,
  onClose = () => {},
  title,
  className = '',
}) => {
  const modal = (
    <div className={`generic-modal ${className}`}>
      <article data-molecule='modal' className='generic-modal__article'>
        <div className='generic-modal__header'>
          <span className=''>{title}</span>
          <button
            className='generic-modal__button-close'
            onClick={() => {
              document.body.style.overflow = 'auto';
              onClose();
            }}
          >
            <FeatherX />
          </button>
        </div>

        <div className='generic-modal__main'>{children}</div>
      </article>
    </div>
  );

  useEffect(() => {
    isOpen && (document.body.style.overflow = 'hidden');
  }, [isOpen]);

  return createPortal(modal, document.body);
};

export default GenericModal;
